import React from 'react'
import Divider from '../../Atoms/Divider/Divider'
import FormProfileEdit from '../../Organisms/FormProfile/FormProfileEdit'

const ManageRolesFormEdit = () => {
  return (
    <div className="nd-grid main-roles">
      <div className="s-main-justify s-cross-center">
        <h1 className="mb-5 poppins-40">Editar perfiles</h1>
      </div>
      <Divider />

      <p className="mb-40 source-20">Edita un perfil de usuario asociado tu cuenta.</p>

      <FormProfileEdit />
    </div>
  )
}

export default ManageRolesFormEdit
